// Client-safe environment (only public VITE_* values reach the browser).
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY ?? '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
  // The studio's Jira site (https://<site>.atlassian.net), for "Open in Jira". Not a
  // secret. Unset hides the link.
  jiraSiteUrl: import.meta.env.VITE_JIRA_SITE_URL ?? '',
} as const;

export const isConfigured = {
  supabase: Boolean(env.supabaseUrl && env.supabaseAnonKey),
  posthog: Boolean(env.posthogKey),
};
